/* dot-grid.js
   The site-wide dotted grid. One fixed canvas, no blend modes (fixed layers with mix-blend-mode are
   unreliable in Safari). Each page section is classified as light or dark from its own background, and
   every dot is drawn in whichever colour contrasts with the section it sits over. On desktop the grid
   also reacts to the cursor. The event page has its own grid and is skipped. */
(function () {
  'use strict';
  if (window.ThirtyDotGrid) return;

  var html = document.documentElement;
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function clamp(v, a, b) { return v < a ? a : (v > b ? b : v); }

  /* ---------- section tone ---------- */
  function parse(col) {
    var m = col && col.match(/rgba?\(([^)]+)\)/);
    if (!m) return null;
    var p = m[1].split(/[ ,\/]+/).filter(Boolean).map(parseFloat);
    return { r: p[0], g: p[1], b: p[2], a: p.length > 3 ? p[3] : 1 };
  }
  function lum(c) { return (0.2126 * c.r + 0.7152 * c.g + 0.0722 * c.b) / 255; }
  // returns 'light', 'dark' or null when the element paints no background of its own
  function ownTone(el) {
    var cs = getComputedStyle(el), c = parse(cs.backgroundColor);
    if (c && c.a > .6) return lum(c) > .55 ? 'light' : 'dark';
    if (cs.backgroundImage && cs.backgroundImage !== 'none' && cs.backgroundImage.indexOf('gradient') === -1) return 'dark';
    return null;
  }
  function findTone(el, depth) {
    var t = ownTone(el);
    if (t) return t;
    if (depth >= 3) return null;
    var kids = el.children, host = el.getBoundingClientRect();
    for (var i = 0; i < kids.length && i < 8; i++) {
      var r = kids[i].getBoundingClientRect();
      if (r.width < window.innerWidth * .85 || r.height < host.height * .5) continue;
      var k = findTone(kids[i], depth + 1);
      if (k) return k;
    }
    return null;
  }

  var bands = [], pageTone = 'light';
  function collect() {
    var bodyTone = ownTone(document.body) || ownTone(html) || 'light';
    pageTone = bodyTone;
    bands = Array.prototype.map.call(document.querySelectorAll('.shopify-section'), function (el) {
      if (el.classList.contains('shopify-section-group-header-group')) return null;
      return { el: el, tone: findTone(el, 0) || bodyTone };
    }).filter(Boolean);
  }
  function toneAt(y, rects) {
    for (var i = 0; i < bands.length; i++) {
      var r = rects[i];
      if (y >= r.top && y < r.bottom) return bands[i].tone;
    }
    return pageTone;
  }

  /* ---------- canvas ---------- */
  function Grid() {
    var cv = document.createElement('canvas');
    cv.className = 'dg-canvas'; cv.setAttribute('aria-hidden', 'true');
    document.body.appendChild(cv);
    var ctx = cv.getContext('2d'), dpr = Math.min(window.devicePixelRatio || 1, 2);
    var W = 0, H = 0, cw = 0, ch = 0, vc = 0;
    var px = -9999, py = -9999, tx = px, ty = py, presence = 0, presenceTarget = 0, seen = false;
    var waves = [], raf = 0, running = false, until = 0;
    var clearSel = 'video, iframe, input, textarea, select, [data-dg-hole]';
    var holes = [], holesAt = 0;
    var mqReactive = window.matchMedia('(min-width:1024px) and (pointer:fine)');

    // The lattice is centred on the viewport: one dot sits exactly on the middle of the screen and the grid
    // is symmetric either side of it. The centre is whole pixels so every dot lands crisply.
    function lattice() {
      var g = W >= 1024 ? 180 : 122, gy = W >= 1024 ? 180 : 128;
      return { gx: g, gy: gy, ox: Math.round(W / 2), oy: vc };
    }
    function resize() {
      var widthChanged = window.innerWidth !== cw;
      W = window.innerWidth; H = Math.max(window.innerHeight, window.screen ? Math.min(window.screen.height, 1400) : 0);
      if (W !== cw || H > ch) {
        cw = W; ch = H;
        cv.width = Math.round(W * dpr); cv.height = Math.round(H * dpr);
        cv.style.height = H + 'px';
        ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      }
      var ih = Math.round(window.innerHeight / 2);
      if (!vc || widthChanged || Math.abs(ih - vc) > 90) vc = ih;
      kick(300);
    }
    function kick(ms) {
      until = Math.max(until, performance.now() + ms);
      if (!running) { running = true; raf = requestAnimationFrame(draw); }
    }
    function reactive() { return !reduced && mqReactive.matches; }
    function onMove(e) {
      if (!reactive()) return;
      tx = e.clientX; ty = e.clientY;
      if (!seen) { px = tx; py = ty; seen = true; }
      presenceTarget = 1; kick(2200);
    }
    function onLeave() { presenceTarget = 0; kick(900); }
    function onDown(e) { if (!reactive()) return; waves.push({ x: e.clientX, y: e.clientY, t: performance.now() }); kick(1800); }
    function onScroll() { kick(140); }

    function draw(now) {
      if (!running) return;
      var L = lattice(), R = 160, FINE = L.gx / 5, react = reactive();
      px += (tx - px) * .14; py += (ty - py) * .14;
      presence += (presenceTarget - presence) * .09;
      ctx.clearRect(0, 0, cw, ch);
      waves = waves.filter(function (w) { return now - w.t < 1700; });
      var rects = bands.map(function (b) { return b.el.getBoundingClientRect(); });
      var LIGHT = '0,0,0', DARK = '255,255,255';
      var iA = -Math.ceil(L.ox / L.gx) - 1, iB = Math.ceil((W - L.ox) / L.gx) + 1;
      var jA = -Math.ceil(L.oy / L.gy) - 1, jB = Math.ceil((H - L.oy) / L.gy) + 1;
      var near = [];

      for (var j = jA; j <= jB; j++) {
        for (var i = iA; i <= iB; i++) {
          var cx = L.ox + i * L.gx, cy = L.oy + j * L.gy;
          if (cx < -20 || cx > W + 20 || cy < -20 || cy > H + 20) continue;
          var col = toneAt(cy, rects) === 'light' ? LIGHT : DARK;
          var dx = cx - px, dy = cy - py, d = Math.sqrt(dx * dx + dy * dy) || 1;
          var k = react && d < R ? Math.pow(1 - d / R, 2) * presence : 0;
          var ox = 0, oy = 0, wk = 0;
          for (var n = 0; n < waves.length; n++) {
            var w = waves[n], age = now - w.t, rw = age * .9;
            var wdx = cx - w.x, wdy = cy - w.y, wd = Math.sqrt(wdx * wdx + wdy * wdy) || 1;
            var e = Math.exp(-Math.pow((wd - rw) / 90, 2)) * Math.exp(-age / 700);
            wk += e * .25; ox += wdx / wd * e * 3; oy += wdy / wd * e * 3;
          }
          var kk = k + wk;
          ox += dx / d * k * 4; oy += dy / d * k * 4;
          ctx.fillStyle = 'rgb(' + col + ')';
          ctx.beginPath(); ctx.arc(cx + ox, cy + oy, 1.15 + kk * .8, 0, 6.2832); ctx.fill();
          if (k > 0 && d < R * .9) near.push({ x: cx + ox, y: cy + oy, a: (1 - d / (R * .9)) * presence, col: col });
        }
      }

      if (react && presence > .02) {
        var pc = toneAt(py, rects) === 'light' ? LIGHT : DARK;
        var i0 = Math.floor((px - R - L.ox) / FINE), i1 = Math.ceil((px + R - L.ox) / FINE);
        var j0 = Math.floor((py - R - L.oy) / FINE), j1 = Math.ceil((py + R - L.oy) / FINE);
        for (var jj = j0; jj <= j1; jj++) {
          for (var ii = i0; ii <= i1; ii++) {
            var fx = L.ox + ii * FINE, fy = L.oy + jj * FINE;
            var fdx = fx - px, fdy = fy - py, fd = Math.sqrt(fdx * fdx + fdy * fdy) || 1;
            if (fd >= R) continue;
            var fk = Math.pow(1 - fd / R, 2) * presence;
            if (fk < .04) continue;
            ctx.fillStyle = 'rgba(' + (toneAt(fy, rects) === 'light' ? LIGHT : DARK) + ',' + Math.min(1, fk * .22).toFixed(3) + ')';
            ctx.beginPath();
            ctx.arc(fx + fdx / fd * fk * 2, fy + fdy / fd * fk * 2, .45 + fk * .45, 0, 6.2832);
            ctx.fill();
          }
        }
        near.sort(function (a, b) { return b.a - a.a; });
        ctx.lineWidth = .5;
        for (var q = 0; q < Math.min(2, near.length); q++) {
          ctx.strokeStyle = 'rgba(' + near[q].col + ',' + (near[q].a * .1).toFixed(3) + ')';
          ctx.beginPath(); ctx.moveTo(px, py); ctx.lineTo(near[q].x, near[q].y); ctx.stroke();
        }
      }

      // keep forms and video clear of dots; content blocks no longer punch dot-free boxes
      if (now - holesAt > 400) { holes = Array.prototype.slice.call(document.querySelectorAll(clearSel)); holesAt = now; }
      holes.forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.bottom < 0 || r.top > H || r.right < 0 || r.left > W || !r.width || !r.height) return;
        ctx.clearRect(r.left - 4, r.top - 4, r.width + 8, r.height + 8);
      });

      var settled = Math.abs(tx - px) < .3 && Math.abs(ty - py) < .3 && Math.abs(presenceTarget - presence) < .01;
      if (now > until && settled && !waves.length) { running = false; return; }
      raf = requestAnimationFrame(draw);
    }

    window.addEventListener('pointermove', onMove, { passive: true });
    window.addEventListener('pointerdown', onDown, { passive: true });
    window.addEventListener('scroll', onScroll, { passive: true });
    document.documentElement.addEventListener('mouseleave', onLeave);
    window.addEventListener('resize', function () { resize(); });
    resize();
    requestAnimationFrame(function () { cv.classList.add('is-on'); });
    return { kick: kick, resize: resize };
  }

  var grid = null;
  function refresh() { collect(); if (grid) grid.kick(200); }

  function boot() {
    // the event page draws its own grid
    if (document.querySelector('.rhl-root')) return;
    collect();
    grid = Grid();
    window.ThirtyDotGrid = { toneAt: function (y) { return toneAt(y, bands.map(function (b) { return b.el.getBoundingClientRect(); })); }, refresh: refresh };
    window.addEventListener('load', refresh);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(refresh);
    setTimeout(refresh, 1200); setTimeout(refresh, 3500);
    document.addEventListener('shopify:section:load', refresh);
    document.addEventListener('shopify:section:unload', refresh);
    window.addEventListener('resize', function () { setTimeout(refresh, 250); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
